import { useState } from 'react';

/** Copies text to the clipboard and announces the outcome. */
export function CopyButton({ text, label }: { text: string; label: string }) {
  const [state, setState] = useState<'idle' | 'copied' | 'failed'>('idle');

  function copy() {
    if (!('clipboard' in navigator)) {
      setState('failed');
      return;
    }
    navigator.clipboard.writeText(text).then(
      () => {
        setState('copied');
      },
      () => {
        setState('failed');
      },
    );
  }

  return (
    <span className="copy-button">
      <button type="button" className="button button--secondary" onClick={copy}>
        {label}
      </button>
      <span role="status" className="meta">
        {state === 'copied' && 'Copied.'}
        {state === 'failed' && 'Copy failed — select the text and copy it manually.'}
      </span>
    </span>
  );
}
